import React from 'react';
import { Route, RouteProps } from 'react-router-dom';

const Public = ({ path, component, ...rest }: RouteProps) => {
	return <Route path={path} component={component} {...rest} />;
};

export default Public;
